import { css, keyframes } from "emotion";

import { GeofenceCategory } from "@cobliteam/common-types";

import { colors } from "@cobliteam/base-components/src/styles/colors";

// Remove navbar height
export const map = css`
  height: 100%;
  width: 100%;

  > div,
  #leaflet-map-tracking {
    height: 100%;
  }

  .leaflet-marker-icon {
    background: none;
    border: none;
  }
`;

export const plannedRoutePath = css`
  stroke: ${colors.primary.default};
  stroke-width: 5;
  stroke-dasharray: 10;
  filter: drop-shadow(0px 4px 4px ${colors.shadows.getShadow("#07074e", 0.2)});
`;

export const routePath = css`
  cursor: default;
  stroke: ${colors.secondary.default};
  stroke-width: 5;
  stroke-opacity: 1;
  filter: drop-shadow(0px 4px 4px ${colors.shadows.getShadow("#07074e", 0.2)});
`;

const categoryColor = (category?: GeofenceCategory) => {
  switch (category) {
    case GeofenceCategory.BASE:
      return colors.primary.default;
    case GeofenceCategory.CLIENT:
      return colors.success.default;
    case GeofenceCategory.OTHER:
      return colors.warning.default;
    default:
      return colors.gray.dark;
  }
};

export const geofence = (category?: GeofenceCategory) => css`
  stroke: ${categoryColor(category)};
  stroke-width: 1;
  stroke-dasharray: 3, 6;
  fill: ${categoryColor(category)};
  fill-opacity: 0.1;
`;

const strokeAnimation = keyframes`
  0% {
    stroke-dashoffset: 100%;
  }

  100% {
    stroke-dashoffset: 0;
  }
`;

export const routePathAnimation = css`
  ${routePath}
  stroke: ${colors.gray.dark};
  stroke-dasharray: 20, 80;
  animation: 25s ${strokeAnimation} linear infinite;
`;

export const textPopup = css`
  width: 230px;
`;

export const footerPopup = css`
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
`;

export const popup = css`
  box-shadow: 2px 2px 10px 0 rgba(157, 169, 182, 0.2);
  border: 1px solid ${colors.gray.light};
  border-radius: 5px;
  box-sizing: content-box;
  background-color: ${colors.white};

  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: inherit;
  }

  .leaflet-popup-content {
    margin: 0;
    border-radius: inherit;
  }
`;
